import { handleRequest } from "../utilities/requestHandler";

export const updateUser = (req_body) => 
    handleRequest("post", "/users/update", req_body);

export const checkUserEmailExists = (email) =>
	handleRequest("post", "/users/check-email", { email });

export const updateRecentSites = (recentSites) =>
	handleRequest("post", "/users/recent-sites", { recent_sites: recentSites });

export const markPageTourCompleted = async (user_id, page_route) => {
	const response = await handleRequest("post", "/auth/page-tour-completed", { 
		user_id, 
		page_route 
	});
	return {
		...response,
		success: response.status
	};
};
